export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, value);
};

export const workingDays = [
  {
    id: 1,
    label: "Monday",
    name: "workingDays.monday",
    value: 1,
  },
  {
    id: 2,
    label: "Tuesday",
    name: "workingDays.tuesday",
    value: 1,
  },
  {
    id: 3,
    label: "Wednesday",
    name: "workingDays.wednesday",
    value: 1,
  },
  {
    id: 4,
    label: "Thursday",
    name: "workingDays.thursday",
    value: 1,
  },
  {
    id: 5,
    label: "Friday",
    name: "workingDays.friday",
    value: 1,
  },
  {
    id: 6,
    label: "Saturday",
    name: "workingDays.saturday",
    value: 0,
  },
  {
    id: 7,
    label: "Sunday",
    name: "workingDays.sunday",
    value: 1,
  },
];

export const LiveUrl = {
  BaseUrl: "https://trans-node.cyrusretail.com.au/v1/",
  driverServiceUrl: "https://driver-mic.cyrusretail.com.au",
};

export const TestUrl = {
  BaseUrl: "https://tst-trans-node.jsuite.in/v1/",
  driverServiceUrl: "https://tst-driver-mic.jsuite.in",
};

export const LocalUrl = {
  BaseUrl: "http://localhost:9100/v1/",
  driverServiceUrl: "http://localhost:9097",
};

const currentEnv = process.env.REACT_APP_ENV;

export const DriverServiceUrl = 
  currentEnv === "local"
    ? LocalUrl.driverServiceUrl
    : currentEnv === "test"
    ? TestUrl.driverServiceUrl
    : LiveUrl.driverServiceUrl;

export const BaseUrl =
  currentEnv === "local"
    ? LocalUrl.BaseUrl
    : currentEnv === "test"
    ? TestUrl.BaseUrl
    : LiveUrl.BaseUrl;

export const STORAGE_KEY = "@dealerId";
export const STORAGE_LEADID = "@leadId";
export const STORAGE_CLIENTID = "@clientid";

export const endpoints = {
  login: "auth/signin",
  getOrdersInvoices: `orders/invoices`,
  getOrdersStockTransfers: `orders/stock-transfers`,
  exportToExcel: `orders/excel`,
  getSettlementList: `settlement`,
  getNoificationCount: `trans/notificationCount`,
  manageExtraCharges: `settlement/manage-extra-charges`,
  settleExtraCharges: `settlement/settle-extra-charges`,
  registerDriver: `app/driver-registration`,
  uploadRunnerSheet: `app/runsheet_master`,
  fetchDrivers: `app/driver-details`,
	fetchDriverDetails: `app/driver-details`,
	updateDriverDetails: `app/driver-update`,
  fetchRunners: `app/fetch-jobdata`,
};
